<template>
    <div class="page-bg login">
        <v-container fill-height justify-center>
            <div class="login-block">
                <div class="Client-logo">
                    <img :src="logo" class="Client-logo-img" />
                </div>
                <v-form class="login-frm">
                    <v-row>
    
                        <v-col cols="12" sm="12" class="pad-zero icon-input">
                            <v-text-field @keydown.space.prevent v-model="password" label="Set New Password" dense outlined :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :type="show1 ? 'text' : 'password'" @click:append="show1 = !show1"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" class="pad-zero">
                            <v-text-field @keydown.space.prevent type='password' v-model="confirmPassword" label="Reconfirm Password" hide-details dense outlined></v-text-field>
                         <InputError :data='error.errConfirmPassword' />
                        </v-col>
                        <v-col cols="12" sm="12" class="pad-zero">
                            <div class="signup-primary top-0">
                                <div class="user-new-signup"> </div>
                                <div class="sign-up-btn">
                                    <v-btn :loading="loading" @click="onGoClick" class="right-btn cust-btn" color="primary">Go</v-btn>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </v-form>
                <div v-if="isDefaultInstitute && myInstitute && !myInstitute.is_white_labeled" class="power-logo">
                    <img src="@/assets/img/logo-footer.png" class="master-logo" />
                </div>
            </div>
        </v-container>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
    name: 'SetPassword',

    data() {
        return {
            show1: false,
            confirmPassword: '',
            password: '',
            loading: false,
            logo: this.getInstituteLogo(),
            error: {               
                errConfirmPassword: {
                    type: null,
                    message: null,
                }
            },
        }
    },
    watch: {
        password(val) {
            if (this.confirmPassword && this.confirmPassword.length) {
                this.setPasswordError(this.confirmPassword);
            }
        },
        confirmPassword(val) {

            this.setPasswordError(val);
        }
    },
    computed:{
       ...mapState('userStore', ['isDefaultInstitute','myInstitute']),
       isPasswordMatch() {
            return this.password === this.confirmPassword;
        }
    },
    methods: {
        ...mapActions({
            resetPassword: "userStore/resetPassword"
        }),
        setPasswordError(val) {
            if (!val || val.length === 0) {
                this.error.errConfirmPassword.type = null;
            } else if (this.isPasswordMatch) {
                this.error.errConfirmPassword.type = 'success';
                this.error.errConfirmPassword.message = 'Passwords match';
            } else {
                this.error.errConfirmPassword.type = 'error';
                this.error.errConfirmPassword.message = 'Passwords do not match';
            }
        },
        onGoClick() {
            if (!this.password) {
                this.$toasted.error("Please enter password");
            }
            if (this.password !== this.confirmPassword) {
                this.$toasted.error("Passwords do not match");
            } else {
                this.loading = true;
                this.resetPassword({ token: this.$route.params.token, password: this.confirmPassword }).then(response => {
                        this.loading = false;
                        this.$toasted.success(`Password reset successfully.`, { icon: 'check_circle' });
                        this.$router.push({ name: "login" }).catch(() => {});
                    })
                    .catch(err => {
                        this.loading = false;
                    });
            }

        }
    }
}
</script>
